import { Component, OnInit } from '@angular/core';
import { AuthUserService } from '../auth-user.service';
import { AuthenticationResult } from '../models/authentication.model';
import { ModalcloseReason, ModalService } from 'hsg';
import { AuthBaseComponent } from '../auth-base/auth-base.component';

@Component({
  selector: 'app-auth-open-calls',
  templateUrl: './auth-open-calls.component.html',
  styleUrls: ['./auth-open-calls.component.css']
})
export class AuthOpenCallsComponent extends AuthBaseComponent implements OnInit {

  ngOnInit(): void {
    this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2180' })
      .subscribe(res => console.log("sent elasticLog code:2180 - open window", res), error => console.log("sent elasticLog - open window error!", error));
    sessionStorage.setItem("currentWindow", "פנייה פתוחה");
    sessionStorage.setItem("elasticCode", "");
  }

  closeOpenCalls(shouldClose): void {
    this.serverError = null;
    // this.authUserService.sendAuthData("CloseOpenCalls", { closeOpenCalls: shouldClose })
    // .subscribe((res: AuthenticationResult) => this.modalService.close({ redirect: true }, ModalcloseReason.action));
    this.authUserService.sendAuthData("CloseOpenCalls", { closeOpenCalls: shouldClose }).subscribe();
    this.modalService.close({ redirect: true }, ModalcloseReason.action);
  }
}
